var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "styling" } },
    [
      _c(
        "ais-instant-search",
        {
          attrs: {
            "search-client": _vm.searchClient,
            "index-name": _vm.index,
            future: { preserveSharedStateOnUnmount: true },
          },
        },
        [
          _c("ais-configure", {
            attrs: { distinct: true, facetFilters: _vm.facetFilters() },
          }),
          _vm._v(" "),
          _vm.iconId != null
            ? _c("ais-hits", {
                staticClass: "app-content",
                attrs: { "transform-items": _vm.transformItems, role: "main" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ items }) {
                        return items.length > 0
                          ? _c("div", {}, [
                              _c(
                                "div",
                                { staticClass: "row margin-bottom-2xl" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "column-12 text-center" },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "text-uppercase size-md with-anchor",
                                          staticStyle: {
                                            "letter-spacing":
                                              "var(--letter-spacing-3xl)",
                                            "font-weight":
                                              "var(--font-weight-black)",
                                            color: "var(--fa-md-gravy)",
                                          },
                                        },
                                        [
                                          _c("anchor-link", {
                                            attrs: {
                                              anchor: "#styling",
                                              "link-color": "gravy",
                                              "anchor-name": "Styling Toolkit",
                                            },
                                          }),
                                          _vm._v(
                                            "\n              Seasoned to Perfection\n            "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("h2", { staticClass: "margin-y-md" }, [
                                        _vm._v("Styling Toolkit"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "line-length-xl margin-auto",
                                        },
                                        [
                                          _vm._v(
                                            "\n              We've seasoned our styling tools to perfection, making icons more flexible right out of the box. With just a pinch of code, you can size, place,\n              style, and even animate any icon for the perfect look.\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row margin-bottom-2xl" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "column-12 text-center" },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "display-flex",
                                          staticStyle: {
                                            "--list-style-type": "none",
                                            gap: "var(--spacing-md)",
                                            "justify-content": "center",
                                            "--button-padding":
                                              "var(--button-padding-vertical) var(--spacing-md)",
                                          },
                                        },
                                        [
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active: _vm.isActive("house"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "house"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid.faHouse,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("house icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active:
                                                    _vm.isActive("face-smile"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "face-smile"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid
                                                      .faFaceSmile,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("face-smile icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active: _vm.isActive("truck"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "truck"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid.faTruck,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("truck icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active: _vm.isActive("image"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "image"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid.faImage,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("image icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active: _vm.isActive("music"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "music"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid.faMusic,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("music icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "button",
                                              {
                                                class: {
                                                  active: _vm.isActive("file"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.iconName = "file"
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.solid.faFile,
                                                    size: "lg",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("file icon")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "card text-left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "wrap-icon-details row roomy align-stretch",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon-detail-grid-preview column-12 margin-bottom-2xl laptop:margin-bottom-0 laptop:column-6",
                                      },
                                      [
                                        _c("icon-preview", {
                                          attrs: {
                                            "preview-mode":
                                              _vm.styling.previewMode,
                                            styling: _vm.styling,
                                            icon: _vm.icon,
                                            "default-styles": _vm.defaultStyles,
                                            "display-icon-preview-controls": true,
                                            "major-version":
                                              _vm.activeMajorVersion,
                                            "is-duotone": _vm.isDuotoneIcon,
                                          },
                                          on: {
                                            resetStyles: _vm.resetStyles,
                                            changePreviewMode:
                                              _vm.changePreviewMode,
                                            toggleStyleOptions:
                                              _vm.toggleStyleOptions,
                                            toggleAnimationOptions:
                                              _vm.toggleAnimationOptions,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon-detail-use column-12 laptop:column-6 margin-bottom-2xl laptop:margin-bottom-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "margin-bottom-2xl" },
                                          [
                                            _c("icon-pack-selector", {
                                              attrs: {
                                                icon: _vm.icon,
                                                styling: _vm.styling,
                                                "major-version":
                                                  _vm.activeMajorVersion,
                                                "default-styles":
                                                  _vm.defaultStyles,
                                              },
                                              on: {
                                                change: (newStyling) =>
                                                  (_vm.styling = newStyling),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("icon-code-snippet", {
                                          attrs: {
                                            id: _vm.icon.name,
                                            "can-download-icon": false,
                                            "default-styles": _vm.defaultStyles,
                                            icon: _vm.icon,
                                            "icon-abstract": _vm.iconAbstract,
                                            "is-duotone": _vm.isDuotoneIcon,
                                            "is-using-modal": false,
                                            showing: _vm.showing,
                                            "is-hiding-svg": true,
                                            styling: _vm.styling,
                                            viggo: _vm.viggo,
                                          },
                                          on: {
                                            show: _vm.changeShowing,
                                            getSelectedAction:
                                              _vm.getSelectedAction,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "display-flex flex-row flex-wrap flex-items-stretch icon-actions",
                                            staticStyle: {
                                              "--button-margin-bottom": "0",
                                              gap: "var(--spacing-md)",
                                            },
                                          },
                                          [
                                            _c(
                                              "site-link",
                                              {
                                                staticClass:
                                                  "button accent position-relative icon-action-start-using",
                                                staticStyle: {
                                                  top: "calc(var(--button-box-shadow-width) * -1)",
                                                },
                                                attrs: {
                                                  to: { name: "start" },
                                                  "aria-label":
                                                    "Set up your web project to use this icon!",
                                                  "data-balloon-pos": "up",
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.$v7.regular
                                                      .faRocketLaunch,
                                                    size: "xl",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "margin-left-2xs",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Start Using This Icon"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            !_vm.isProPlusIcon
                                              ? _c(
                                                  "site-link",
                                                  {
                                                    staticClass:
                                                      "button position-relative icon-action-customize",
                                                    staticStyle: {
                                                      top: "calc(var(--button-box-shadow-width) * -1)",
                                                      "flex-grow": "0",
                                                      "padding-right":
                                                        "var(--spacing-md)",
                                                    },
                                                    attrs: {
                                                      to: _vm.$docs(
                                                        "/web/add-icons/icon-wizard"
                                                      ),
                                                      "aria-label":
                                                        "Magically add modifiers to this icon!",
                                                      "data-balloon-pos": "up",
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: _vm.$v7.solid
                                                          .faSquareDashedCirclePlus,
                                                        size: "xl",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr-only",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Add Modifiers with the Icon Wizard"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon-detail-styling-tabs column-12",
                                      },
                                      [
                                        _c("icon-styling", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isShowingStyleOptions,
                                              expression:
                                                "isShowingStyleOptions",
                                            },
                                          ],
                                          attrs: {
                                            icon: _vm.icon,
                                            styling: _vm.styling,
                                            "major-version":
                                              _vm.activeMajorVersion,
                                            "default-styles": _vm.defaultStyles,
                                          },
                                          on: {
                                            change: (newStyling) =>
                                              (_vm.styling = newStyling),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("icon-animations", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isShowingAnimationOptions,
                                              expression:
                                                "isShowingAnimationOptions",
                                            },
                                          ],
                                          attrs: {
                                            icon: _vm.icon,
                                            styling: _vm.styling,
                                            "major-version":
                                              _vm.activeMajorVersion,
                                          },
                                          on: {
                                            change: (newStyling) =>
                                              (_vm.styling = newStyling),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e()
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }